export const styleDataGridDefault = {
    '& .MuiSvgIcon-root': {
        fontSize: 'large',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
};
